export default "__VITE_ASSET__CUkeOgoR__"